import React, { Fragment } from 'react';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs';
import DefaultContain from '../../../Component/DashBoard/Default/index';
import { useTranslation } from 'react-i18next';


const Default = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Breadcrumbs parent={t("Dashboards")} title={t("Default")} />
      {<DefaultContain />}
    </Fragment>
  );
};
export default Default;
